import { WhiteBorderButton } from '@elements/Button';
import { MuteText } from '@elements/Common';
import { DarkPopup } from '@elements/Popup';
import { Info } from '@phosphor-icons/react';
import { AppTableHeaderCell } from '@components/AppTable';

export function ShipmentViewQuickView({ totalItems, openPopup, value, items }) {
  return (
    <DarkPopup
      trigger={
        <div className="sk:flex! sk:items-center! sk:cursor-pointer">
          <span>{totalItems}</span>
          <span>
            <Info className="sk:mt-1! sk:ml-1!" />
          </span>
        </div>
      }
      hoverable
    >
      <div className="sk:flex! sk:items-center!">
        <b>Boxes</b>
        <WhiteBorderButton
          className="sk:ml-2! sk:p-2!"
          onClick={openPopup}
          size="tiny"
        >
          Edit
        </WhiteBorderButton>
      </div>
      <table
        cellSpacing={0}
        className="sk:mt-2! sk:w-full sk:[&_td]:border-0 sk:[&_td]:border-t sk:[&_td]:border-solid sk:[&_td]:border-current/20 sk:[&_td]:p-1.25 sk:[&_th]:p-1.25 sk:[&_th]:text-left sk:[&_th]:font-normal"
      >
        <thead>
          <th className="sk:whitespace-nowrap">Box Information</th>
          <AppTableHeaderCell className="sk:whitespace-nowrap sk:px-2!" />
          {value?.map?.((boxInfo, index) => (
            <th className="sk:whitespace-nowrap sk:pl-2!">Box {index + 1}</th>
          ))}
        </thead>
        <tbody>
          <tr>
            <td />
            <td className="sk:px-2!">
              <div className="sk:flex! sk:flex-col!">
                <MuteText className="sk:whitespace-nowrap">
                  Weight (lb)
                </MuteText>
                <MuteText className="sk:whitespace-nowrap">
                  Length (in)
                </MuteText>
                <MuteText className="sk:whitespace-nowrap">Width (in)</MuteText>
                <MuteText className="sk:whitespace-nowrap">
                  Height (in)
                </MuteText>
              </div>
            </td>
            {value?.map?.(boxInfo => (
              <td className="sk:pl-2!">
                <div className="sk:flex! sk:flex-col! sk:items-center!">
                  <span>{boxInfo?.weight?.value}</span>
                  <span>
                    {boxInfo.dimensions?.length || boxInfo?.length?.value}
                  </span>
                  <span>
                    {boxInfo.dimensions?.width || boxInfo?.width?.value}
                  </span>
                  <span>
                    {boxInfo.dimensions?.height || boxInfo?.height?.value}
                  </span>
                </div>
              </td>
            ))}
          </tr>
          {items.map(item => (
            <tr className="top-border">
              <td className="sk:whitespace-nowrap">{item.sku}</td>
              <td className="sk:px-2!" />
              {value?.map?.(boxInfo => (
                <td className="sk:pl-2!">{boxInfo?.items?.[item.sku]}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </DarkPopup>
  );
}
